import { FC, useEffect, useState } from "react"
import * as Yup from "yup"
import { Form, Formik } from "formik"
import AuthServices from "@lib/api/services/auth.services"
import { setCookie } from "nookies"
import { domainChecker } from "@lib/functions"
import { FlexBox } from "@components/wrapper"
import { Modal, ModalProps } from "./Modal"
import { RegularButton, GoogleLoginButton } from "@components/button"
import { FormikInput, PasswordInput } from "@components/input"

export interface LoginModalProps extends ModalProps {
  redirect?: string
}

export const LoginModal: FC<LoginModalProps> = ({ show, onClose, redirect, ...props }) => {
  const [validation, setValidation] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [validationRequired, setValidationRequired] = useState(false)

  useEffect(() => {
    if (!show) {
      setValidation("")
    }
  }, [show])

  const auth = new AuthServices()

  const validationSchema = Yup.object({
    email: Yup.string().email("Email tidak valid").required("Email harus diisi"),
    password: Yup.string().required("Password harus diisi"),
  })

  function errorMessageGenerator(msg: string) {
    setValidation(msg)
  }

  return (
    <Modal
      {...props}
      show={show}
      onClose={onClose}
      contentClassName="max-w-md rounded-10"
      contentPadding="p-0"
    >
      <div className="sm:pt-[30px] pt-4 sm:px-[30px] px-2">
        <div className="mb-5 font-semibold text-center text-2xl">Login</div>

        <GoogleLoginButton handleError={errorMessageGenerator} redirect={redirect} />
        <div className="h-3 my-10 text-center border-b-grey-97 border-b">
          <span className="bg-white px-3.5">atau</span>
        </div>

        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={validationSchema}
          validateOnChange={validationRequired}
          validateOnBlur={validationRequired}
          onSubmit={async (value) => {
            setValidation("")
            setIsLoading(true)
            try {
              const res = await auth.manualLogin(value)

              if (res.isFailure) {
                const err = res.error
                setValidation(err.message)
                setIsLoading(false)
              } else {
                const result = res.getValue()

                if (result.data.status_completed_profile) {
                  if (!redirect) {
                    window.location.reload()
                  } else {
                    window.location.assign(redirect)
                  }
                } else {
                  setCookie(null, "HS_TEMP", JSON.stringify(result.data), {
                    path: "/",
                    domain: domainChecker(),
                  })

                  window.location.assign("/biodata")
                }
              }
            } catch (e: any) {
              console.log(e)
              setValidation("Terjadi kesalahan. Cek kembali data yang diinput dan coba lagi")
              setIsLoading(false)
            }
          }}
        >
          <Form>
            <FormikInput placeholder="Masukkan e-mail kamu" name="email" className="mb-6" />

            <PasswordInput placeholder="Masukkan password kamu" name="password" className="mb-6" />

            <RegularButton
              className="mt-6 w-full py-3.5 rounded"
              isSubmitting={isLoading}
              onClick={() => setValidationRequired(true)}
              isFormik
            >
              Masuk
            </RegularButton>
          </Form>
        </Formik>

        <div className="mt-2.5 text-red">{validation}</div>
        <div className="mt-4 mb-5 text-center">
          <a href={"/lupa-password"} className="text-green font-semibold text-center">
            Lupa Password?
          </a>
        </div>
      </div>

      <FlexBox className="p-6 border-t-[#dee2e6] border-t" justify="center">
        Belum bergabung?{" "}
        <a href={`/register`} className="ml-1.5 text-green font-semibold">
          Daftar Akun
        </a>
      </FlexBox>
    </Modal>
  )
}
